import axios, { AxiosResponse } from 'axios'

import { MailchimpSettingsRead, MailchimpSettingsWrite, PerformanceId } from '@generated/types'

const BASE_URL = '/api/mailchimp'

export default {
  async fetchSettings(): Promise<AxiosResponse<MailchimpSettingsRead>> {
    return axios.get(`${BASE_URL}/`)
  },

  async updateSettings(
    settings: MailchimpSettingsWrite,
  ): Promise<AxiosResponse<MailchimpSettingsRead>> {
    return axios.put(`${BASE_URL}/`, settings)
  },

  async fetchAudiences(): Promise<AxiosResponse> {
    return axios.get(`${BASE_URL}/audiences/`)
  },

  async disconnect(): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/disconnect/`)
  },

  async createTemplate(
    performanceIds: PerformanceId[],
  ): Promise<AxiosResponse<{ template_url: string }>> {
    return axios.post(`${BASE_URL}/create-template/`, { performance_ids: performanceIds })
  },
}
